import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { ResourcesItem } from 'redux-and-the-rest';

import './SecondaryNav.scss';
import { MenuItem } from '../../models/menuItem';
import { getUser } from '../../redux/reducers/userReducer';
import { ApplicationState } from '../../redux/types';
import { UserModel } from '../../models/userModel';
import HorizontalScroller from '../shared/HorizontalScroller';

interface Props {
  user: ResourcesItem<UserModel>
  menuItems: MenuItem[];
}

const SecondaryNav = ({ user, menuItems }: Props): React.ReactElement => {
  const { values: { roles: userRoles } } = user;
  const userRoleIds = userRoles.map(({ id }) => id);

  return (
    <div className="secondary-nav">
      <HorizontalScroller>
        <nav className="list">
          {menuItems
            .filter(({ roles: roleIds }) => roleIds && roleIds.some((roleId) => userRoleIds.includes(roleId)))
            .map(({ title, href }) => (
              <NavLink
                key={title}
                to={href}
                title={title}
                className="button list-item"
                activeClassName="on"
              >
                {title}
              </NavLink>
            ))}
        </nav>
      </HorizontalScroller>
    </div>
  );
};

const mapReduxStateToProps = ({ users }: ApplicationState) => ({
  user: getUser(users),
});

export default connect(mapReduxStateToProps)(SecondaryNav);
